<template>
  <Uploader
    v-bind="$attrs"
    @uploaded="$emit('uploaded', $event)"
  >
    <template v-if="hasExtendedBtns" #actions>
      <uploader-btn
        v-if="allowZip"
        url="v1/files/upload/zip"
        accept=".zip, application/zip"
        class="q-mr-sm"
        :category="$attrs.category || null"
        :multiple="false"
        :btn-props="zipBtnProps"
        @start="$loading.show({message: 'Importing & extracting ZIP. Please wait...'})"
        @finish="$loading.hide()"
        @uploaded="$emit('uploaded', $event)"
      >
        <q-tooltip>Import & extract a ZIP file. {{ maxFileSizeStr }}</q-tooltip>
      </uploader-btn>
    </template>
  </Uploader>
</template>

<script>
import Uploader from './Uploader.vue'

export default {
  components: {
    Uploader
  },
  props: {
    allowZip: {
      type: Boolean,
      default: false
    }
  },
  emits: ['start', 'finish', 'uploaded', 'added'],
  computed: {
    zipBtnProps () {
      return {
        label: 'Import ZIP',
        noCaps: true,
        color: 'blue-grey-8',
        icon: 'mdi-folder-zip'
      }
    },
    maxFileSizeStr () {
      const fileSizeLimit = this.$store.getters.getSystemSetting('max_file_size') || 0
      if (fileSizeLimit > 0) {
        return `Maximum ${fileSizeLimit}MB.`
      }
      return ''
    },
    hasExtendedBtns () {
      return this.can(this.permissions.canAccessFiles) && this.allowZip
    }
  }
}
</script>
